<template>
 <v-dialog v-model="show" persistent max-width="650px">



   <RemoveWindow 
        v-model="dialogDelete"   Type="Archive" :removeItem="Mapp"  Headline="Arkivera kartläggning för" WarningText="Är du säker på att du vill arkivera kartläggningen? När en kartläggning är arkiverad kan inte skolpersonal lägga till eller ändra sina svar. Åtkomst till resultaten kvarstår för Elevhälsoteam."    />
    <v-card v-if="Mapp.answer!=null">
                 <v-toolbar
          color="green lighten-3"
          dark
        >

          <v-toolbar-title   class="headline">Kartläggning {{Mapp.name}}</v-toolbar-title>
        </v-toolbar>
            <v-card-text>
              <v-container>


  <v-btn
               xs2
                :disabled="choose==='Alla' "
                  
                  outline
                  round
                  small
                  color="red"
                  @click="choose='Alla'"
                >
                 Alla
                </v-btn>
  <v-btn
              
                  v-for="name in answerNames"
                  xs2
                  :key="name"
                  round
                  outline
                  small
                  :disabled="choose===name?true:false "
                  color="green"
                  @click="choose=name"
                >
                  <!-- @click="choose=name;changeData()" -->
                
                  {{
                   name
                  }}
                </v-btn>
<div v-if="choose!='Alla' && choose!='' ">
<h2>Svar från {{choose}}:</h2>

<!-- <div v-for="Question in Questions" :key="Question.Q">
<div v-if="showData=='All' || showData==Question.C ">
<h2>{{Question.Q}}</h2>
<Dataview v-if="Question.C=='free'" :Data="Question.A" :People="answerNames" />
<BarReady v-else  :labels="getTexts(Question.T)" :dataset="Question.A" />
</div>
</div> -->
<!-- {{Mapp.answer[answerNames.find(X => X== choose  )]}}
-->
<DataviewOneperson :Name="choose" :Data="dataMash()" /> 
</div>
<div v-else>
<h1>Spindeln</h1>
 <v-flex justify="center">

<RadarReady :dataset="Mapp.answer" />
  <v-tooltip bottom   v-for="(name, index) in Names"
                  :key="name">
  <template v-slot:activator="{ on, attrs }">
          <v-btn
           
            class="mx-2"
            fab
            dark
            outline
            small
            @click="showData=name"
            color="green ligthen-1"
               v-bind="attrs"
                  v-on="on"
          >
            <v-icon dark>  {{Icons[index]}} </v-icon>
          </v-btn>
  </template>
  
              <span>  {{Texts[index]}}</span>
            </v-tooltip>

 </v-flex>
<div v-for="Question in Questions" :key="Question.Q">
<div v-if="showData=='All' || showData==Question.C ">
<h2>{{Question.Q}}</h2>
<Dataview v-if="Question.C=='free'" :Data="Question.A" :People="answerNames" />
<BarReady v-else  :labels="getTexts(Question.T)" :dataset="Question.A" />
</div>
</div>
</div>

              </v-container>
            </v-card-text>
            <v-card-actions>


              <v-spacer></v-spacer>
                   <v-btn 
                color="red lighten-1"
                text
                dark
                @click="dialogDelete=true"
          
              >
               {{Mapp.hasOwnProperty('archive')?'Arkiverad': 'Arkivera'}}
              </v-btn>
              <v-spacer></v-spacer>

                            <v-btn
                color="green lighten-1"
                text
                dark
                @click="change()"
          
              >
               Stäng
              </v-btn>
            </v-card-actions>
          </v-card>
          
 </v-dialog>
</template>
<script>
import RemoveWindow from "../assets/RemoveWindow";
import BarReady from './Charts/BarReady.vue'
import { mapActions,mapGetters } from "vuex";
import RadarReady from './Charts/RadarReady.vue';
import fun from "../functions";
import Dataview from './Charts/Dataview.vue';
import DataviewOneperson from './Charts/DataviewOneperson.vue';
export default {
    name:"Answers",
      components: {BarReady,
            RadarReady,RemoveWindow,
            Dataview,
            DataviewOneperson
  },

  mounted() {
//   let a= this.Mapp.answer;
//   let id = this.Mapp.answerId;
//  (a)
//   let all = [0,0,0,0]
//   let ind = [[],[],[],[]]
//   // a.forEach(e => {
//     for (let e = 0; e < a.length; e++) {
//     for (let i = 0; i < a[e].answers.length; i++) {
//       all[i] = (  all[i]+ a[e].answers[i]);
//       // all[i].push(  a[e].answers[i]);
//       // ind[i].push(  a[e].answers[i]);
      
//     }
//   };
//    (all)
  //  (ind)

  },
  computed: {
    ...mapGetters('teachers', [ 'teachernameandId']),

    ...mapGetters('ehtmembers', ['member']),

    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },

    created(){
      //  (this.Mapp.name+" create")
    this.locfun = new fun();


this.changeData();
  this.answerNames=this.Mapp.answerId.map(ID => this.locfun.getName(
              ID,
              this.teachernameandId,
              []
            ))
    },
    props:{
        Mapp: Object,
        value: Boolean
    },
data() {
    return {
       Questions: [
        { Q: "Styrkor", T: "T"  ,C: "free"}, //0  
        { Q: "Huvudsakliga problem", T: "T" ,C: "free"},   //1      
        { Q: "Inlärning och perception", T: "Goals" ,C: "health"}, //2 MÅL kunskapsinhämtning
        { Q: "Läsförmåga:", T: "Goals" ,C: "cunning"}, //3 Kunskapsinhämtning 
        { Q: "Skrivförmåga:", T: "Goals" ,C: "cunning"},//4 Kunskapsinhämtning
        { Q: "Elevens förmåga att ta till sig undervisning:", T: "Working" ,C: "cunning"},//5 Kunskapsinhämtning 
        { Q: 'Aktivitetskontroll: "Skatta förmåga att påbörja skolarbete"', T: "Working" ,C: "impuls"},//6 impuls  
        { Q: 'Aktivitetskontroll: "skatta förmåga att avsluta skolarbete"', T: "Working" ,C: "impuls"},//7 impuls 
        { Q: 'Aktivitetskontroll: "skatta förmåga att ta till sig och förstå instruktioner:"', T: "Working" ,C: "cunning"}, //8 kunskapsinhämtning
        { Q: "Impulskontroll:", T: "Age" , E: "åldersadvekat" ,C: "impuls"}, //9 impuls
        { Q: "Uppmärksamhet:", T: "Age" , E: "åldersadvekat" ,C: "impuls"}, //10 impuls
        { Q: "Fokus", T: "Age" , E: "åldersadvekat" ,C: "impuls"},         //11 impuls
        { Q: "Planera och genomföra skolarbete:", T: "Working2" ,C: "goal"}, //12 mål   
        { Q: "Skatta elevens sociala samspel med skolpersonal", T: "Working",C: "social" }, //13 social
        { Q: "Skatta elevens sociala samspel med andra elever", T: "Working" ,C: "social"},           //14 social
        { Q: "Kommunikationsförmåga", T: "Working" ,C: "cunning"}, //15 kunskap 
        { Q: "Språkliga nivå:", T: "Age" , E: "åldersadvekat" ,C: "cunning"}, //16 kunskap
        { Q: "Förmåga att redovisa kunskaper:", T: "Working2"  ,C: "goal"}, //17  mål
        { Q: "Finmotorik:", T: "Working" ,C: "health"},                     //!8 hälsa
        { Q: "Grovmotorik:", T: "Working" ,C: "health"},                     //!9 hälsa
        { Q: "Närvaro:", T: "Working" ,C: "prescene"},                     //20 närvaro
        { Q: "Psykiska hälsa:", T: "Good" ,C: "health"},                     //21 hälsa
        { Q: "Elevens fysiska hälsa:", T: "Good" ,C: "health"},                     //22 hälsa
         { Q: "Övrig information som är relevant för kartläggningen", T: "T" ,C: "free" },      //23
      ],
      choose:'Alla',
        // YesNo: [
        //   "Ja",
        //   "Nej",
        //   "Vet ej"
        // ],
                Good: [
          "Bra",
          "Mindre bra",
          "Vet ej"
        ],
                Goals: [
          "Når målen",
          "Når ej målen",
          "Vet inte"
        ],
                Age: [
          "Åldersadvekat",
          "Icke åldersadvekat",
          "Vet inte"
        ],
                Working: [
          "Huvudsakligen fungerande",
          "Ej fungerande",
          "Vet inte"
        ],
            Working2: [
          "Huvudsakligen fungerande och uppfyller målen",
          "Huvudsakligen fungerande",
          "Ej fungerande",
          "Vet inte"
        ],
          Texts:["Alla","Fritext","Hälsa","Kunskapsinhämtning","Impulskontroll","Social","Närvaro","Måluppfyllelse"],
       
        Names:["All","free","health","cunning","impuls","social","prescene","goal"],
        Icons: ["all_inclusive","article","favorite","psychology","bolt","groups","alarm_off","flag"],
       showData: "All",
        //                 Elementary: [
        //   "Grundläggande",
        //   "Icke grundläggande",
        //   "Vet inte"
        // ],
  Answers:[],
         update:false ,
         dialogDelete:false,
         answerNames:[],
    };
  },

  methods: {
    ...mapActions("classesAP", ["createAP","saveAP"]),
    ...mapActions(['showSuccessSnackbar']),

getTexts( textType){
  if (textType=="Good") {
    return this.Good
  }
    else if (textType=="Goals") {
    return this.Goals
  }
    else if (textType=="Age") {
    return this.Age
  }
    else if (textType=="Working") {
    return this.Working
  }
    else if (textType=="Working2") {
    return this.Working2
  }
  //     else if (textType=="Elementary") {
  //   return this.Elementary
  // }
},
changeData(){
  let m =  this.Mapp.answer
//  (this.choose)
  if(this.choose!="Alla")
 m = [ this.Mapp.answer[ this.answerNames.findIndex(X => X== this.choose )]]
for (let i = 0; i < this.Questions.length; i++) {
  // const element = Questions[i];
  this.Questions[i].A=  m.map(X => X.answers[i]) //Mapp.answer.answers[i]
}
// this.Questions.push({})
// this.Questions.pop();
},

dataMash(){
let Info=[]
let m =  this.Mapp.answer[ this.answerNames.findIndex(X => X== this.choose )]
for (let i = 0; i < m.answers.length; i++) {
Info.push({question: this.Questions[i].Q, T: this.Questions[i].T,answer:m.answers[i]})
}
return Info
},

  change(){
    //  (this.Questions.length+" "+(this.Questions.length/100)+" " +this.Answers.length)
    // let legitA= this.Answers.filter(item => item!=null)
    // let rest= legitA.length/ this.Questions.length;
    //  (rest)
    // let output={teacherId: this.id,id:student.id , answers: this.Answers,step: rest}
    //    (output)

     this.show = false;
  }
    
  }
}
</script>
<style >

</style>